import {get, post ,postJson} from '../libs/api.request'

//获取联系我们
export const _getContactUsList = () => get('contact/us');